const BASE_URL = `${window.location.protocol}//${window.location.host}`;

export async function getAll(filters = {}) {
    const query = new URLSearchParams();

    if (filters.username) {query.append('username', filters.username); }

    if (filters.groupId) { query.append('groupId', filters.groupId); }

    if (filters.isActive !== undefined) {query.append('isActive', filters.isActive); }

    const queryString = query.toString();
    const url = queryString 
    ? `${BASE_URL}/api/administration/accessUser?${queryString}`
    : `${BASE_URL}/api/administration/accessUser`

    const res = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
    });

    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        data = null;
    }

    // Throw only for unexpected statuses (500 etc)
    if (res.status >= 500) {
        throw new Error(data?.error || `Server error (${res.status})`);
    }
    return { status: res.status, ok: res.ok, data };
}

export async function getById(userId) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser/${userId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });

    const text = await res.text();
    const data = text ? JSON.parse(text) : null;

    // Throw only for unexpected statuses (500 etc)
    if (res.status >= 500) {
        throw new Error(data?.error || `Server error (${res.status})`);
    }

    return { status: res.status, ok: res.ok, data };
}

export async function create(userObject) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userObject),
  });

  if (!res.ok) {
    const text = await res.text();
    let detail = '';
    try {
        const body = text ? JSON.parse(text) : null;
        if (body?.details?.length) {
            detail = ': ' + body.details.join(', ');
        } else if (body?.message) {
            detail = ': ' + body.message;
        }
    } catch {
        // ignore parse errors
    }
    throw new Error(`Failed to create user (${res.status})${detail}`);
  }

  return { status: res.status, ok: res.ok };
}

export async function update(userId, userObject) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userObject),
  });

  if (!res.ok) {
    throw new Error(`Failed to update user: ${res.status}`);
  };

  return { status: res.status, ok: res.ok };
}

export async function remove(userId) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser/${userId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) {
        throw new Error(`Failed to delete user: ${res.status}`);
    }

    return { status: res.status, ok: res.ok };
}

export async function patch(id, updates) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates),
    });
    
    if (!res.ok) {
        throw new Error(`Failed to update users status: ${res.status}`);
    };

    return { status: res.status, ok: res.ok };
}

export async function setPassword(userId, newPassword) {
    const res = await fetch(
        `${BASE_URL}/api/administration/accessUser/${userId}/password`,
        {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ newPassword }),
        }
    );
    if (!res.ok) {
        throw new Error(`Failed to change user password: ${res.status}`);
    }

    return { status: res.status, ok: res.ok };
}

export async function importX3Users(userObject) {
    const res = await fetch(`${BASE_URL}/api/administration/accessUser/import`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userObject),
  });

  const text = await res.text();
  const data = text ? JSON.parse(text) : null;

  // Throw only for unexpected statuses (500 etc)
  if (res.status >= 500) {
    throw new Error(data?.error || `Server error (${res.status})`);
  }

  return { status: res.status, ok: res.ok, data };
}